/* Hide mystery product sku */

function hideMysteryProductSKU() {
    const mysterySkuList = ['SKU# HAT25-001-OS'];
    const skuElements = document.querySelectorAll('.variant-sku, .sku');
    skuElements.forEach(skuElement => {
        const skuText = skuElement.textContent.trim();
        if (mysterySkuList.includes(skuText)) {
            skuElement.style.display = 'none';
        }
    });

    
}

/* Execution */

window.addEventListener('DOMContentLoaded', () => {
    hideMysteryProductSKU();
    
    //Attach function to search input
    setTimeout(() => {
        document.addEventListener('keypress', (event) => {
            
            if (event.target.getAttribute('data-predictive-search-input') == "true") {
                setTimeout(hideMysteryProductSKU, 200);
                
            }
        })
    }, 300);
});

